import {Alert} from "antd";
import {
  ServiceOrderDrawerOrderInfoOrderDetails,
  ServiceOrderDrawerOrderInfoOrderDetailsProps,
} from "./order-details";
import {
  ServiceOrderDrawerOrderInfoOrderTime,
  ServiceOrderDrawerOrderInfoOrderTimeProps,
} from "./order-time";
import {StyledServiceOrderDrawerOrderInfo} from "./styles";
import {ServiceOrderWorkDelivery} from "./work-delivery";
import {WarningFilled} from "@ant-design/icons";
import {GetStoreServiceOrderApiResponse} from "../../../../../../../react-query-hooks/store/services/get-store-service-order/types";

export type ServiceOrderDrawerOrderInfoProps = ServiceOrderDrawerOrderInfoOrderTimeProps &
  ServiceOrderDrawerOrderInfoOrderDetailsProps & {
    productServiceDeliveries: GetStoreServiceOrderApiResponse["order"]["productServiceDeliveries"];
  };

export function ServiceOrderDrawerOrderInfo({
  orderTime,
  status,
  customerEmail,
  customerName,
  deliveryInfo,
  price,
  productServiceDeliveries,
}: ServiceOrderDrawerOrderInfoProps) {
  return (
    <StyledServiceOrderDrawerOrderInfo>
      <ServiceOrderDrawerOrderInfoOrderTime orderTime={orderTime} status={status} />
      <ServiceOrderDrawerOrderInfoOrderDetails
        customerEmail={customerEmail}
        customerName={customerName}
        deliveryInfo={deliveryInfo}
        price={price}
      />
      {status === "disputeOpened" && (
        <Alert
          type="error"
          icon={<WarningFilled />}
          showIcon
          message="Dispute in progress."
          description={
            <p style={{color: "#8C8C8C"}}>
              Dispute resolution takes 3 to 5 days. Our team will be in touch with you.
            </p>
          }
        />
      )}

      <ServiceOrderWorkDelivery
        status={status}
        productServiceDeliveries={productServiceDeliveries}
      />
    </StyledServiceOrderDrawerOrderInfo>
  );
}
